import {EventModel} from 'event/models/Event'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import {formatUserDate} from 'utils/lib/date'
import {useI18n} from 'i18n/I18nContext'

export function PublishSection(props: {
  event: EventModel | null
  handlePublicClick: () => void
  loading: boolean
}) {
  const {event, handlePublicClick, loading} = props
  const {t} = useI18n()

  if (!event) return null

  if (event?.is_ended) {
    return (
      <>
        <PublishedDate>
          {t('orgPublish.publishedOn')} {formatUserDate(event.published_at)}
        </PublishedDate>
        <PublishedDate>
          {t('orgPublish.endedOn')} {formatUserDate(event.ended_at)}
        </PublishedDate>
      </>
    )
  }

  if (event?.is_public) {
    return (
      <>
        <PublishedDate>
          {t('orgPublish.publishedOn')} {formatUserDate(event.published_at)}
        </PublishedDate>

        <EndDate>
          {t('orgPublish.autoEndLead')} <br />
          {formatUserDate(
            moment(event.date)
              .add(event.duration, 'days')
              .subtract(1, 'minute')
              .toDate(),
          )}
        </EndDate>
      </>
    )
  }

  return (
    <button
      type="button"
      onClick={handlePublicClick}
      disabled={loading}
      className={'pricing__btn'}
    >
      {t('orgPublish.publish')}
    </button>
  )
}

const PublishedDate = styled.div`
  text-align: center;
  font-weight: bold;
`

const EndDate = styled.div`
  text-align: center;
  margin-top: 10px;
  font-weight: bold;
  color: #ff0000;
`
